export const permissionAdmin = 'admin';
